import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  private url = environment.baseUrl + '/help';

  constructor(private httpClient: HttpClient) {
  }

  getListOfHelpInfo(componentName: string): Observable<HelpDTO[]> {
    return this.httpClient.get<HelpDTO[]>(this.url + '/' + componentName);
  }
}
